import CardCommon from '@op/components/CardCommon';
import React, { useMemo, useState } from 'react';
import {
  CommunityOptionsType,
  MentionsSentimentSubSortType,
  TableHeight,
} from '../constants';
import TableCommonHook from '@op/components/TableCommonHook';
import useCompareKeyMetricsColumns from '@op/components/TableCommonHook/hooks/useCompareKeyMetricsColumns';
import { useCompareKeyMetricsTable } from '../hooks';
import { dealwithMentionsSentimentTable } from '../utils';
import { useDownloadParams } from '@op/hooks/useDownloadParams';
import { useMetricsChannel } from '@op/hooks/useMetricsChannel';
export default function CommunityTable({
  filter,
  tab,
  gameData,
  getOtherParams,
  gameInfo,
}: {
  filter: any;
  tab: CommunityOptionsType;
  getOtherParams: (tab: CommunityOptionsType) => any;
  gameData: {
    [id: string]: {
      name: string;
      color: string;
    };
  }[];
  gameInfo: any;
}) {
  const [sorts, setSorts] = useState<{
    by: MentionsSentimentSubSortType;
    order: 'desc' | 'asc';
  }>({
    by: 'by_mentions',
    order: 'desc',
  });

  const MergeChannelIconElement = useMetricsChannel({ gameInfo });

  const { downloadLegacy, downloading } = useDownloadParams();

  const params = useMemo(() => {
    const otherParams = getOtherParams(tab);

    return {
      ...filter,
      ...otherParams,
      tab_type: tab,
      stats_types: ['community'],
    };
  }, [filter, tab]);

  const { tableRecords, loading } = useCompareKeyMetricsTable({
    filter: params,
    dealwithToTable: dealwithMentionsSentimentTable,
    gameData,
    defaultSortKey: 'impressions',
  });

  const { columns, sortColumns } = useCompareKeyMetricsColumns({
    oneKey: 'Community',
    twoKey: tab,
    tableRecords,
    gameData,
    filter,
    MergeChannelIconElement,
  });

  return (
    <CardCommon
      contentCard
      className="mentions-sentiment-table-wrapper"
      hasDownload
      loading={loading}
      loadingHeight={265}
      downloadLoading={downloading}
      handleDownloadOnClick={() => {
        downloadLegacy({
          params: {
            ...params,
            gameData,
          },
          downloadFunc: 'getOverviewCompetitorTable',
          sheetName: 'Compare Key Metrics Community Table',
          simpleName: 'Compare Key Metrics Community Table',
        });
      }}
      logBtnId="Community Table"
    >
      <TableCommonHook
        columns={columns}
        hasPageable={false}
        maxHeight={TableHeight.BELOW}
        sortColumns={sortColumns}
        records={tableRecords}
        bordered="all"
        sortType={'local'}
        logBtnId="Community"
      ></TableCommonHook>
    </CardCommon>
  );
}
